module.exports = __webpack_public_path__ + "static/media/_LotNew.bf39d11b.jpg";